import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'Am mai investit în dezvoltare personală și nu am văzut schimbări majore. De ce ar fi diferit acum?',
    a: 'Pentru că, de obicei, ai lucrat pe bucăți: mindset într-un loc, emoții în altul, teorie separat. A.R.I.S.E. este diferită pentru că lucrează simultan pe toate nivelurile care creează blocajul. Nu adaugi încă o informație, creezi integrare.'
  }, {
    q: 'Nu am suficient timp. Pot totuși să particip?',
    a: 'Programul este creat exact pentru femei ocupate. Ai una sau două sesiuni pe lună și lucrezi în ritmul tău pe module. Nu este încă un lucru pe lista ta, ci procesul care schimbă modul în care trăiești tot restul.'
  }, {
    q: 'Mi-e teamă că va fi prea intens emoțional. Ce se întâmplă?',
    a: 'Este un proces profund, dar este ghidat. Nu ești forțată, nu ești expusă fără suport. Lucrăm într-un ritm care permite integrarea. Nu este despre intensitate, este despre siguranță în profunzime.'
  }, {
    q: 'Ce se întâmplă dacă nu reușesc să duc programul până la capăt?',
    a: 'Programul este construit progresiv, nu copleșitor. Ai ghidare, structură și suport continuu. În realitate, majoritatea participantelor descoperă că, odată ce încep să vadă primele schimbări, programul devine prioritate.'
  }, {
    q: 'De ce este necesară aplicarea? Nu mă pot înscrie direct?',
    a: 'Pentru că grupul este limitat intenționat, ca să păstrez calitatea procesului. Aplicarea nu este o barieră, este un filtru pentru potrivirea corectă. Vreau să fiu sigură că programul este potrivit pentru tine, înainte să investești.'
  }, {
    q: 'Care este diferența dintre Pachetul Standard și Pachetul VIP?',
    a: 'Pachetul Standard îți dă accesul complet la cele 9 module, workshop-urile lunare de grup și comunitatea. Pachetul VIP adaugă o sesiune lunară de grup pentru aprofundare, 2 sesiuni individuale 1:1 cu mine și prioritate în răspuns. VIP este pentru cine vrea un ritm mai personalizat.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 md:py-28 bg-ivory overflow-hidden" data-id="element-314">
      <div className="max-w-[900px] mx-auto px-6 md:px-8" data-id="element-315">
        <div className="text-center mb-16" data-id="element-316">
          <FadeIn data-id="element-317">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-6" data-id="element-318">
              Întrebări frecvente
            </h2>
          </FadeIn>
        </div>

        <div className="space-y-4" data-id="element-319">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-320">
              <div className={`border rounded-[20px] overflow-hidden transition-colors duration-300 ${openIndex === index ? 'bg-white border-gold/40 shadow-md' : 'bg-white/50 border-gold/20 hover:border-gold/40'}`} data-id="element-321">
                <button className="w-full text-left px-6 py-5 md:px-8 md:py-6 flex items-center justify-between gap-4 focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-322">
                  <span className="text-[19px] font-medium text-forest pr-8" data-id="element-323">
                    {faq.q}
                  </span>
                  <div className={`w-8 h-8 rounded-full bg-gold/10 flex items-center justify-center shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180 bg-gold/20' : ''}`} data-id="element-324">
                    <ChevronDown className="w-5 h-5 text-forest" data-id="element-325" />
                  </div>
                </button>

                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-326">
                  <div className="px-6 pb-6 md:px-8 md:pb-8 pt-0 text-[18px] text-charcoal/70 leading-relaxed border-t border-gold/10 mt-2" data-id="element-327">
                    {faq.a}
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}